"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { rem, Box, Container as Container$1 } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/Container.css';const wrapper = "_wrapper_1rcj6_2";
const root = "_root_1rcj6_10";
const background = "_background_1rcj6_39";
const ContainerStyles = {
  wrapper,
  root,
  background
};
const _Container = forwardRef((props, ref) => {
  const {
    className,
    children,
    size = 1136,
    background: background2,
    center,
    p,
    pl,
    pr,
    pt,
    pb,
    ...rest
  } = props;
  const resolvedSize = {
    base: 1136,
    xs: 1136,
    sm: 1136,
    md: 1136,
    lg: 1136,
    xl: 1136
  };
  if (size === "global") {
    resolvedSize.base = 1296;
    resolvedSize.xs = 1296;
    resolvedSize.sm = 1296;
    resolvedSize.md = 1296;
    resolvedSize.lg = 1296;
    resolvedSize.xl = 1296;
  } else if (typeof size === "number") {
    resolvedSize.base = size;
    resolvedSize.xs = size;
    resolvedSize.sm = size;
    resolvedSize.md = size;
    resolvedSize.lg = size;
    resolvedSize.xl = size;
  } else if (typeof size === "object") {
    resolvedSize.base = size.base || resolvedSize.base;
    resolvedSize.xs = size.xs || size.base || resolvedSize.base;
    resolvedSize.sm = size.sm || size.xs || size.base || resolvedSize.base;
    resolvedSize.md = size.md || size.sm || size.xs || size.base || resolvedSize.base;
    resolvedSize.lg = size.lg || size.md || size.sm || size.xs || size.base || resolvedSize.base;
    resolvedSize.xl = size.xl || size.lg || size.md || size.sm || size.xs || size.base || resolvedSize.base;
  }
  const styleVariables = {
    "--passed-size-base": rem(resolvedSize.base),
    "--passed-size-xs": rem(resolvedSize.xs),
    "--passed-size-sm": rem(resolvedSize.sm),
    "--passed-size-md": rem(resolvedSize.md),
    "--passed-size-lg": rem(resolvedSize.lg),
    "--passed-size-xl": rem(resolvedSize.xl)
  };
  return /* @__PURE__ */ jsx(Box, { ...rest, component: "section", className: `${ContainerStyles.wrapper} ${className}`, children: /* @__PURE__ */ jsx(Box, { className: ContainerStyles.background, mod: { variant: background2, center }, children: /* @__PURE__ */ jsx(
    Container$1,
    {
      className: ContainerStyles.root,
      ref,
      style: styleVariables,
      p,
      pl,
      pt,
      pr,
      pb,
      children
    }
  ) }) });
});
_Container.displayName = "Container";
const Container = sharedHandler(_Container);
Container.displayName = _Container.displayName;
export {
  ContainerStyles as C,
  Container as default
};
